import { Box, Typography } from "@mui/material";

import CreateSKUDialogContainer from "./components/CreateSKUDialogContainer";
import SKUsTable from "./components/SKUsTable";

const SKUsPage = (): JSX.Element => {
  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">System Templates</Typography>
        <CreateSKUDialogContainer />
      </Box>
      <SKUsTable />
    </Box>
  );
};

export default SKUsPage;
